import {ChangeDetectorRef, Component, enableProdMode, LOCALE_ID, OnInit, ViewChild} from '@angular/core';
import {ChildrenOutletContexts, provideRouter,withComponentInputBinding, RouterModule} from '@angular/router';  // Remove RouterModule.forRoot()
import {HashLocationStrategy, LocationStrategy, CommonModule} from '@angular/common';
import {environment} from '../environments/environment';
import {HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {LocalizationInterceptor} from '@core/interceptors/localization.interceptor';
import {JWTInterceptor} from '@core/interceptors/jwt.interceptor';
import {APP_ROUTES} from './app.routes';
import {provideAnimations} from '@angular/platform-browser/animations';
import {OfficeService} from '@core/services/office.service';
import {filter, take} from 'rxjs/operators';
import {AnimationService} from "@core/services/anmation.service";
import {CustomHashLocationStrategy} from "./custom-hash-location-strategy";
import {LoadingPageComponent} from "@core/loading-page/loading-page.component";

export function getBaseUrl() {
	return document.getElementsByTagName('base')[0].href;
}

if (environment.production) {
	enableProdMode();
}

export function getApiUrl(locale = 'en-US') {
	if (!environment.production && environment.apiUrl) {
		return environment.apiUrl;
	}
	let url = document.getElementsByTagName('base')[0].href;
	if (locale !== 'en-US') {
		url = url.replace(`/${locale}/`, '/');
	}
	return url;
}

declare var Office: any;

@Component({
	selector: 'app-root',
	templateUrl: './app.component.html',
	styles: [],
	standalone: true,
    imports: [RouterModule, CommonModule, LoadingPageComponent],
	providers: [
		{provide: LocationStrategy, useClass: HashLocationStrategy}, // Use HashLocationStrategy, CustomHashLocationStrategy
		{provide: 'BASE_URL', useFactory: getBaseUrl, deps: []},
		{
			provide: LOCALE_ID,
			useValue: typeof $localize !== 'undefined' && $localize.locale ? $localize.locale : 'en-US'
		},
		{provide: 'API_URL', useFactory: getApiUrl, deps: [LOCALE_ID]},
		{provide: HTTP_INTERCEPTORS, useClass: JWTInterceptor, multi: true},
	],
})
export class AppComponent implements OnInit {
	isLoading = true;

	constructor(
		private changeDetectorRef: ChangeDetectorRef,
		private officeService: OfficeService
	) {
	}

	ngOnInit() {
		// Check if we're in Office context by looking for Office object
		const isInOfficeContext = typeof Office !== 'undefined';

		if (isInOfficeContext) {
			// Wait for Office to initialize with a minimum loading time
			const minimumLoadingTime = 5000; // 5 seconds minimum
			const startTime = Date.now();

			this.officeService.isInitialized
				.pipe(
					filter(initialized => initialized || initialized === false),
					take(1)
				)
				.subscribe(() => {
					const elapsedTime = Date.now() - startTime;
					const remainingTime = Math.max(0, minimumLoadingTime - elapsedTime);

					if (remainingTime > 0) {
						// Wait for the remaining time before hiding loading
						setTimeout(() => {
							this.isLoading = false;
							this.changeDetectorRef.detectChanges();
						}, remainingTime);
					} else {
						this.isLoading = false;
						this.changeDetectorRef.detectChanges();
					}
				});
		} else {
			// Not in Office context, show loading for a brief moment for consistency
			setTimeout(() => {
				this.isLoading = false;
				this.changeDetectorRef.detectChanges();
			}, 5000);
		}
	}
}
